import * as moment from 'moment'
import MainConfig from '../config/main'

export class PaymentHelper {
    /**
     *
     * @param user
     * @param commonSetting
     *
     * @return boolean
     */
    static checkNeedPaymentInfo(user, commonSetting): boolean {
        return !this.isTrialTime(user)
            && !(commonSetting.timezone && commonSetting.address && commonSetting.city
                && commonSetting.contactPerson && commonSetting.clinicName && commonSetting.phone)
    }

    /**
     *
     * @param user
     *
     * @return boolean
     */
    static isTrialTime(user) {
        const dateCompare = moment().subtract(MainConfig.WARNING_PAYMENT_DATE, 'days').format('YYYY-MM-DD')
        return !user.created_at || user.created_at > dateCompare
    }
}



// WEBPACK FOOTER //
// ./src/helper/payment.helper.ts